import mime from 'mime-types';

const DEFAULT_FILE_BASENAME = 'attachment';

export type NormalizedFileMetadata = {
  name: string;
  type?: string;
};

type NormalizeFileMetadataParams = {
  originalName?: string | null;
  mimeType?: string | null;
  fallbackBaseName?: string;
};

const ensureString = (value?: string | null): string | undefined => {
  const trimmed = value?.trim();
  return trimmed && trimmed.length > 0 ? trimmed : undefined;
};

export const hasFileExtension = (fileName?: string): boolean => {
  if (!fileName) {
    return false;
  }

  // Matches ".ext" at the end of the string (avoids hidden files like ".gitignore")
  return /\.[^./\\]+$/.test(fileName);
};

export const normalizeFileMetadata = ({
  originalName,
  mimeType,
  fallbackBaseName = DEFAULT_FILE_BASENAME,
}: NormalizeFileMetadataParams): NormalizedFileMetadata => {
  const safeBaseName = ensureString(fallbackBaseName) ?? DEFAULT_FILE_BASENAME;
  const sanitizedName = ensureString(originalName);
  let resolvedType = ensureString(mimeType);

  if (!resolvedType && sanitizedName) {
    const lookedUp = mime.lookup(sanitizedName);
    if (typeof lookedUp === 'string') {
      resolvedType = lookedUp;
    }
  }

  const extensionFromType =
    resolvedType && typeof resolvedType === 'string'
      ? mime.extension(resolvedType)
      : undefined;

  let finalName = sanitizedName;

  if (!finalName) {
    finalName = extensionFromType ? `${safeBaseName}.${extensionFromType}` : safeBaseName;
  } else if (!hasFileExtension(finalName) && extensionFromType) {
    finalName = `${finalName}.${extensionFromType}`;
  }

  return {
    name: finalName,
    type: resolvedType ?? undefined,
  };
};


